// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3NcQW","label":"Completed_label__1Kt1u"};